/* unplugin-vue-components disabled */import { render } from "./NoticePage.vue?vue&type=template&id=a3b5c954&scoped=true"
import script from "./NoticePage.vue?vue&type=script&lang=js"
export * from "./NoticePage.vue?vue&type=script&lang=js"

import "./NoticePage.vue?vue&type=style&index=0&id=a3b5c954&scoped=true&lang=css"
import "./NoticePage.vue?vue&type=style&index=1&id=a3b5c954&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3b5c954"]])

export default __exports__